export default __webpack_public_path__ + "static/media/6.3.c8a163ee.jpg";